<script setup>
import { Head, Link } from '@inertiajs/vue3';

// Add CSS for avatar animations
const style = document.createElement('style');
style.textContent = `
  .avatar-item {
    transition: all 0.6s ease-in-out;
  }
  
  .avatar-item.animate {
    opacity: 1 !important;
    transform: scale(1) !important;
  }
  
  .avatar-item:nth-child(1) { transition-delay: 0.1s; }
  .avatar-item:nth-child(2) { transition-delay: 0.2s; }
  .avatar-item:nth-child(3) { transition-delay: 0.3s; }
  .avatar-item:nth-child(4) { transition-delay: 0.4s; }
  .avatar-item:nth-child(5) { transition-delay: 0.5s; }
  .avatar-item:nth-child(6) { transition-delay: 0.6s; }
  .avatar-item:nth-child(7) { transition-delay: 0.7s; }
`;
document.head.appendChild(style);
import ShinyButton from '@/Components/ShinyButton.vue';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import Testimonials from '@/Components/Testimonials.vue';
import Footer from '@/Components/Footer.vue';
import MainNav from '@/Components/MainNav.vue';
import Comparison from '@/Components/Comparison.vue';
import CookieConsent from '@/Components/CookieConsent.vue';
import HeroSectionA from '@/Components/HeroSectionA.vue';
import HeroSectionB from '@/Components/HeroSectionB.vue';
import HeroSectionC from '@/Components/HeroSectionC.vue';


//import { ref, onMounted } from 'vue';


defineProps({
    canLogin: {
        type: Boolean,
    },
    canRegister: {
        type: Boolean,
    },
  //  styles: Array,
    packages: Array,
    clothing_man: Array,
    clothing_woman: Array,
});

/* function handleImageError() {
    document.getElementById('screenshot-container')?.classList.add('!hidden');
    document.getElementById('docs-card')?.classList.add('!row-span-1');
    document.getElementById('docs-card-content')?.classList.add('!flex-row');
    document.getElementById('background')?.classList.add('!hidden');
} */
import { ref, onMounted, onUnmounted } from 'vue';


const scrollContainer = ref(null);
const avatarContainer = ref(null);
const styleType = ref(null);
const showFullRow = ref(false);

// A/B Testing logic for hero section
const getHeroVariant = () => {
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('ver') || 'a'; // Default to variant A
    }
    return 'a';
};

const heroVariant = getHeroVariant();


const scrollToAnchor = (anchorId) => {
    // Clear any auto-scroll intervals to prevent interference
    if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
    }
    
    const element = document.getElementById(anchorId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    }
};

let autoScrollInterval = null;
let imagepadding = 16;

const scrollLeft = (userInitiated = false) => {
    if (userInitiated) {
        clearInterval(autoScrollInterval);
    }
    const figureWidth = scrollContainer.value.querySelector('figure').offsetWidth;
    scrollContainer.value.scrollBy({
        left: -(figureWidth + imagepadding),
        behavior: 'smooth'
    });
    scrollContainer.value.style.scrollBehavior = 'smooth';
    scrollContainer.value.style.transitionTimingFunction = 'ease-in-out';
};

const scrollRight = (userInitiated = false) => {
    if (userInitiated) {
        clearInterval(autoScrollInterval);
    }
    const figureWidth = scrollContainer.value.querySelector('figure').offsetWidth;
    if (scrollContainer.value.scrollLeft + scrollContainer.value.clientWidth >= scrollContainer.value.scrollWidth) {
        scrollContainer.value.scrollTo({
            left: 0,
            behavior: 'smooth'
        });
    } else {
        scrollContainer.value.scrollBy({
            left: figureWidth + imagepadding,
            behavior: 'smooth'
        });
    }
    scrollContainer.value.style.scrollBehavior = 'smooth';
    scrollContainer.value.style.transitionTimingFunction = 'ease-in-out';
};

autoScrollInterval = setInterval(() => scrollRight(), 3000);

/* FAQ Section */

const faqs = ref([
    { question: 'What is HeadshotOnline and how does it work?', answer: 'HeadshotOnline uses advanced AI technology to create professional headshots from your uploaded photos. You provide a set of diverse images, and the AI trains a custom model to generate high-quality headshots with various styles, clothes and backgrounds.' },
    { question: 'How can I make my headshots look their best?', answer: 'Provide high-quality, well-lit photos with a variety of poses and expressions. You can use selfies, but try to take them against different backgrounds and at least a few set of clothes. Make sure the lens doesn\'t distort your proportions. This helps the AI generate more natural and polished headshots.' },
    { question: 'What kind of photos should I upload for the best results?', answer: 'Upload 10-15 DIVERSE well-lit photos featuring different angles, expressions, outfits, and lighting conditions. Avoid heavy makeup and accessories for a more natural look. The AI learns the common features across photos, so try to avoid using photos with the same clothes.' },
    { question: 'How long does it take to generate my headshots?', answer: 'The process usually takes 2-3 hours. You’ll receive an email notification once your headshots are ready for download.' },
    { question: 'Are the AI-generated headshots suitable for professional use?', answer: 'Yes, the headshots are designed to meet professional standards and are perfect for LinkedIn, resumes, and other professional platforms.' },
    { question: 'What if the AI generates some odd-looking photos?', answer: 'Our AI generates a large set of headshots, some of which will look odd or unusual. However, you should receive at least several high-quality headshots. If not, we offer a money-back guarantee!' },
    { question: 'What if I’m not satisfied with the headshots?', answer: 'If you don’t find any decent headshots and haven’t downloaded any, we offer a full refund! Contact support within 3 days of receiving your headshots.' },
    { question: 'Who owns the generated headshots?', answer: 'You own the full rights to your generated headshots, including commercial use, as outlined in our terms of service.' },
    { question: 'Can I use HeadshotOnline for free?', answer: 'HeadshotOnline is a paid service to cover the computational costs.' },
    { question: 'Is my data safe with HeadshotOnline?', answer: 'Yes, we prioritize your privacy. Your uploaded photos are used solely for generating headshots and are deleted within 30 days. You can also delete them manually anytime.' },

    { question: 'Can I use my AI headshots on social media?', answer: 'Absolutely! Our headshots are optimized for professional and social platforms like LinkedIn, Twitter, and Facebook and dating apps.' },

]);

const activeFaq = ref(null);

const toggleFaq = (index) => {
    activeFaq.value = activeFaq.value === index ? null : index;
};



//full screen image
// State variable to track the full-screen image
const fullscreenImage = ref(null);

// Method to show the full-screen image
const showFullscreen = (image) => {
    fullscreenImage.value = image;
    document.body.style.overflow = 'hidden'; // Prevent scrolling when image is fullscreen
};

// Method to close the full-screen image
const closeFullscreen = () => {
    fullscreenImage.value = null;
    document.body.style.overflow = ''; // Restore scrolling when image is closed
};

// Avatar animation observer
let avatarObserver = null;

const setupAvatarAnimation = () => {
    if (avatarContainer.value) {
        avatarObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const avatars = entry.target.querySelectorAll('.avatar-item');
                    avatars.forEach(avatar => {
                        avatar.classList.add('animate');
                    });
                    avatarObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -50px 0px'
        });
        
        avatarObserver.observe(avatarContainer.value);
    }
};

// Lifecycle hooks
onMounted(() => {
    setupAvatarAnimation();
});

onUnmounted(() => {
    if (avatarObserver) {
        avatarObserver.disconnect();
    }
});




</script>


<style>
.gradient-text {
    background: linear-gradient(90deg, #0e4aba, #6e91c2);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


.hero-bg {
    background-color: #042a76;
    position: relative;
    overflow: hidden;
}

.hero-bg::before {
    content: '';
    position: absolute;
    top: -200px;
    left: -200px;
    width: 300%;
    height: 300%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 10%, transparent 10%),
        radial-gradient(circle, rgba(255, 255, 255, 0.15) 15%, transparent 15%),
        radial-gradient(circle, rgba(255, 255, 255, 0.2) 20%, transparent 20%),
        radial-gradient(circle, rgba(255, 255, 255, 0.25) 25%, transparent 25%),
        radial-gradient(circle, rgba(255, 255, 255, 0.3) 30%, transparent 30%);
    background-size: 150px 150px, 200px 200px, 250px 250px, 300px 300px, 350px 350px;
    background-position: 0 0, 50px 50px, 100px 100px, 150px 150px, 200px 200px;
    opacity: 0.3;
    z-index: 1;
    filter: blur(4px);
    background-blend-mode: screen;
    animation: moveBackground 60s infinite linear;
}

@keyframes moveBackground {
    0% {
        transform: translate(0, 0);
        easing: ease-in-out;
    }

    25% {
        transform: translate(100px, 100px);
        easing: ease-in;
    }

    50% {
        transform: translate(200px, 0px);
        easing: ease-out;
    }

    75% {
        transform: translate(100px, 100px);
        easing: ease-in;
    }

    100% {
        transform: translate(0, 0);
        easing: ease-out;
    }
}

.hero-bg::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.9));
    z-index: 1;
}

.hero-bg>* {
    position: relative;
    z-index: 2;
}





.gallery-item {
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 10px 20px rgba(25, 25, 25, 0.2);
    /*    border: 1px solid rgba(240, 240, 250, 0.1); */
}


/* removed empty hover ruleset to satisfy linter */

.gallery-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(0, 1, 30, 0.0), rgba(1, 1, 30, 0.3));
    opacity: 0;
    transition: opacity 0.3s ease;
}

.gallery-item::before {
    opacity: 1;
}

.main-heading {
    color: #f0f4ff;
    /* Closer to white with a tinge of dark navy */
}
</style>



<template>

    <Head title="#1 most realistic business headshot maker from selfies, in 2 hours, from home!" />
    <!-- Sticky Navigation -->
    <MainNav :can-login="canLogin" :can-register="canRegister" />


    <CookieConsent />

    

        <!-- Hero Section - A/B/C Testing -->
    <HeroSectionA v-if="heroVariant === 'a'" :can-register="canRegister" />
    <HeroSectionB v-else-if="heroVariant === 'b'" :can-register="canRegister" />
    <HeroSectionC v-else-if="heroVariant === 'c'" :can-register="canRegister" />
    <HeroSectionA v-else :can-register="canRegister" />
    <!-- Main Content -->

    <!-- sections -->

    <!-- Prominent stats row -->
    <section id="stats" class="w-full relative text-white border-y border-blue-900/70">
        <div class="absolute inset-0 bg-gradient-to-r from-blue-950 via-blue-900 to-blue-950"></div>
        <div class="absolute inset-0 opacity-40" style="background: radial-gradient(100% 80% at 50% 0%, rgba(59,130,246,0.25) 0%, rgba(59,130,246,0.10) 45%, transparent 70%);"></div>
        <div class="container mx-auto px-4 md:px-6 py-6 md:py-5 relative">
            <!-- Mobile: Stacked layout for better visibility -->
            <div class="md:hidden space-y-4 text-center">
                <div class="text-lg font-bold text-white">The #1 Headshot AI for Business</div>
                
                <!-- Customer avatars and rating - larger on mobile -->
                <div class="flex flex-col items-center space-y-3">
                    <!-- Customer avatars - bigger on mobile -->
                    <div class="flex -space-x-3" ref="avatarContainer">
                        <img src="/img/gallery/references/1.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/2.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/3.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/4.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/5.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/6.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                        <img src="/img/gallery/references/7.jpeg" alt="Happy customer" class="avatar-item w-12 h-12 md:w-8 md:h-8 rounded-full border-2 border-white/20 object-cover shadow-lg opacity-0 transform scale-75">
                </div>
                
                    <!-- Star rating - larger on mobile -->
                    <div class="flex items-center">
                        <svg v-for="i in 5" :key="'b2-'+i" class="w-6 h-6 md:w-4 md:h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.457a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.457a1 1 0 00-1.175 0l-3.38 2.457c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z"/>
                        </svg>
                        <span class="text-lg md:text-base font-bold text-white ml-2">4.87/5 stars</span>
                    </div>
                </div>
            
                <div class="text-lg font-bold text-white">175,000+ portraits delivered</div>
            </div>
          
            <!-- Desktop: Original horizontal layout -->
            <div class="hidden md:flex items-center justify-center flex-wrap gap-x-6 gap-y-2 text-sm md:text-base">
                <span class="text-gray-100 font-semibold opacity-95">The #1 Headshot AI for Business</span>
                <span class="mx-3 h-4 w-px bg-blue-200/30"></span>
                
                <!-- Customer avatars and rating -->
                <div class="flex items-center gap-2">
                    <!-- Customer avatars -->
                    <div class="flex -space-x-2">
                        <img src="/img/gallery/references/1.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/2.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/3.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/4.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/5.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/6.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
                        <img src="/img/gallery/references/7.jpeg" alt="Happy customer" class="w-8 h-8 rounded-full border-2 border-white/20 object-cover">
            </div>

                    <!-- Star rating -->
                    <div class="flex items-center ml-3">
                <svg v-for="i in 5" :key="'b2-'+i" class="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.457a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.457a1 1 0 00-1.175 0l-3.38 2.457c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z"/>
                </svg>
                <span class="text-gray-100 font-semibold opacity-95 ml-2">4.87/5 stars</span>
            </div>
                </div>
                
                <span class="mx-3 h-4 w-px bg-blue-200/30"></span>
            <span class="text-gray-100 font-semibold opacity-95">175,000+ portraits delivered</span>
            </div>
        </div>
    </section>

<!-- 
    <section class="py-16 bg-gray-50 text-center">
        <div class="container mx-auto px-6 py-8">
            <h1 class="text-5xl font-semibold mb-4">
                <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text py-6">So
                    real</span>, you won't believe it's not a physical photo shoot.
            </h1>
            <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em]">
                We make the highest-quality headshots and our customers are absolutely loving them.
            </h3>
                <Testimonials></Testimonials>
        </div>
    </section> -->


<!-- How It Works Section -->
<section class="py-20 pb-18 bg-white text-center" id="learnmore">
            <div class="container mx-auto px-2 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4">
                    Our AI turns selfies into <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">stunning business headshots</span>
                     
                </h1>
                <div class="flex flex-col md:flex-row items-center">
                    <div class="px-4 py-4 md:py-6 mx-auto sm:max-w-xl lg:max-w-screen-xl lg:px-8 lg:py-10">
                        <div class="grid gap-4 md:gap-8 row-gap-0 lg:grid-cols-1">
                            <div class="relative text-center">
                                <div class="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 mx-auto mb-2 md:mb-4 rounded-full bg-blue-500 text-white shadow-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                                    </svg>
                                </div>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-lg md:text-xl font-semibold text-gray-700 tracking-[.011em]">
                                    Send a few pictures of your face.
                                </p>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-sm md:text-md text-gray-500">
                                    We need a few casual photos to build a 3D virtual model of your appearance. No need to dress up, your face is enough.
                                </p>
                            </div>
                            <div class="flex justify-center items-center m-3 md:m-6">
                                <svg class="w-6 md:w-8 text-gray-700 transform rotate-90" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                    <line fill="none" stroke-miterlimit="10" x1="2" y1="12" x2="22" y2="12"></line>
                                    <polyline fill="none" stroke-miterlimit="10" points="15,5 22,12 15,19 "></polyline>
                                </svg>
                             </div>
                            <div class="relative text-center">
                                <div class="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 mx-auto mb-2 md:mb-4 rounded-full bg-blue-500 text-white shadow-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                                    </svg>
                                </div>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-lg md:text-xl font-semibold text-gray-700 tracking-[.011em]">
                                    Our AI creates a digtal 3D model
                                </p>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-sm md:text-md text-gray-500">
                                    The AI photographer learns what you look like, while you relax.
                                </p>
                            </div>
                            <div class="flex justify-center items-center m-3 md:m-6">
                                <svg class="w-6 md:w-8 text-gray-700 transform rotate-90" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                    <line fill="none" stroke-miterlimit="10" x1="2" y1="12" x2="22" y2="12"></line>
                                    <polyline fill="none" stroke-miterlimit="10" points="15,5 22,12 15,19 "></polyline>
                                </svg>
                             </div>
                            <div class="relative text-center">
                                <div class="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 mx-auto mb-2 md:mb-4 rounded-full bg-blue-500 text-white shadow-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                    </svg>
                                </div>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-lg md:text-xl font-semibold text-gray-700 tracking-[.011em]">
                                    Get professional headshots in ~2 hours
                                </p>
                                <p class="max-w-md mb-2 md:mb-3 sm:mx-auto text-sm md:text-md text-gray-500">
                                    Sharpest outfits, coolest backgrounds, perfect poses are just a few clicks away.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div id="column-right" class="w-full md:w-1/2 mt-4 md:mt-6 lg:mt-0 py-8 md:py-16 relative">
                        <div class="relative">
                            <!-- Main AI-generated result image with rounded corners -->
                            <div class="rounded-2xl overflow-hidden shadow-md">
                                <img src="/img/result_example.jpg" alt="AI-generated professional headshot" class="w-full h-full object-cover">
                            </div>
                            
                            <!-- Overlay selfies image positioned 20px lower -->
                            <div class="absolute" style="bottom: -80px; left: 0; right: 0;">
                                <img src="/img/selfies_example.png" alt="Input selfies" class="w-full h-auto object-contain ">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>






        <!-- Social Proof Section -->
        <section class="py-24 bg-gray-50 text-center">
        <div class="container mx-auto px-2 sm:px-6">
            <h1 class="text-5xl font-semibold mb-4">
                Our customers <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">love them</span>.
            </h1>
            <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em]">From resumes to portfolios, professionals choose us for headshots that elevate their brand.</h3>

            <!-- component -->
            <Testimonials></Testimonials>

<!--             <div class="mt-6">
                <svg width="100%" height="auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 400" class="mx-auto rounded-lg shadow-lg">
                    <rect width="640" height="400" fill="lightgray" />
                </svg>
            </div> -->
        </div>
        </section> 






        <!-- Styles Section -->

        <section id="examples" class="py-24 bg-white text-center">
            <div class="container mx-auto px-2 sm:px-6">
                <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">

                    <!-- First Row -->
                    <div class="col-span-2 flex flex-col gap-4">
                        <div class="w-full h-full rounded-xl p-8 bg-gradient-to-tl from-white to-gray-100 shadow-sm">
                            <h1 class="text-5xl font-semibold mb-4 py-10">
                                <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">Skip
                                    the studio</span>, capture the styles
                            </h1>
                            <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em]">Get stunning headshots with professional attire and beautiful backgrounds, all from the comfort of your home. Our AI ensures your photos look indistinguishable from reality!</h3>
                        </div>
                    </div>
                    <div @click="styleType = 'woman'; showFullRow = true; scrollToAnchor('stylelist');"
                        class="min-h-[200px] flex w-full overflow-hidden rounded-xl bg-gray-300 bg-cover bg-center border cursor-pointer transition-transform duration-300 hover:scale-105 active:border-blue-900 active:scale-95"
                        style="background-image:url(/img/gallery/11.jpg)">
                        <p class="text-white text-lg font-bold mt-auto w-full p-2 bg-black bg-opacity-70">
                            See styles for women
                        </p>
                    </div>
                    <div @click="styleType = 'man'; showFullRow = true; scrollToAnchor('stylelist');"
                        class="min-h-[200px] flex w-full overflow-hidden rounded-xl bg-gray-300 bg-cover bg-center border cursor-pointer transition-transform duration-300 hover:scale-105 active:border-blue-900 active:scale-95"
                        style="background-image:url(/img/gallery/14.jpg)">
                        <p class="text-white text-lg font-bold mt-auto w-full p-2 bg-black bg-opacity-70">
                            See styles for men
                        </p>
                    </div>

                    <!-- Second Row -->
                    <div id="stylelist"
                        :class="showFullRow ? 'col-span-2 lg:col-span-4 grid-cols-1' : 'col-span-2 lg:col-span-4 grid-cols-4'"
                        class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full relative pt-16">

                        <div v-if="styleType === 'woman'"
                            :class="showFullRow ? 'col-span-2 lg:col-span-4 grid-cols-1' : 'col-span-2 lg:col-span-4 grid-cols-4'">
                        </div>

                        <div v-if="!showFullRow"
                            class="absolute inset-0 bg-gradient-to-t from-white to-transparent h-1/10">
                        </div>
                    </div>

                    <div :class="showFullRow ? 'col-span-2 lg:col-span-4 grid-cols-1' : 'col-span-2 lg:col-span-4 grid-cols-4'"
                        class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full relative">
                        <div v-for="(clothing, index) in (styleType === 'woman' ? clothing_woman : clothing_man).slice(0, showFullRow ? 12 : 4)"
                            :key="clothing.id"
                            class="relative overflow-hidden rounded-xl bg-cover bg-center border lg:min-h-[400px] cursor-zoom-in"
                            @click="showFullscreen(`/img/combos/${styleType ? styleType : (index % 2 === 0 ? 'woman' : 'man')}${(index % 10) + 1}-${clothing.id}@1x.jpg`)">
                            <img :src="`/img/combos/${styleType ? styleType : (index % 2 === 0 ? 'woman' : 'man')}${(index % 10) + 1}-${clothing.id}@1x.jpg`" class="w-full h-auto rounded-xl shadow-md">
                            <div class="absolute bottom-0 left-0 right-0 bg-gray-800 bg-opacity-75 text-white text-center py-1 text-[10px]">
                                <span v-if="styleType">{{ clothing.name }}</span>
                            </div>
                        </div>
                        <div v-if="!showFullRow"
                            class="absolute inset-0 bg-gradient-to-t from-white to-transparent h-1/10">
                        </div>
                    </div>
                    <div v-if="fullscreenImage"
                        class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-zoom-out"
                        @click="closeFullscreen">
                        <img :src="fullscreenImage" class="max-h-full max-w-full">
                    </div>

                </div>
                <h3 v-if="showFullRow" class="text-gray-500 p-4">This is just a sample of available styles - there are over 100 clothing and backdrop combinations to choose from!
                </h3>
                <h3 v-if="!showFullRow" @click="showFullRow = true;"
                    class="text-sm text-gray-500 cursor-pointer mt-2 flex justify-center hover:text-blue-800">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
                    </svg>
                </h3>
            </div>
        </section>


        <!-- Pricing Section -->
        <section id="pricing" class="py-20 bg-gray-50 text-center">
            <div class="container mx-auto px-2 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4 pt-20">
                    <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">Pro quality</span>, without a pro price
                </h1>
                <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em] pb-14">Get high-end headshots without
                    the
                    high-end studio cost, risk-free. </h3>
                <div class="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 justify-center items-stretch">
                    <div class="bg-white p-8 rounded-lg shadow-lg transform transition-transform hover:scale-105">
                        <h2 class="text-2xl font-semibold mb-4">{{ packages[0].name }}</h2>
                        <p class="text-4xl font-bold mb-4">${{ packages[0].price }}</p>
                        <ul class="text-left mb-6 space-y-2">
                            <li class="flex items-center flex-shrink-0">

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>


                                {{ packages[0].photo_count }} headshots
                            </li>
                            <li class="flex items-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                {{ packages[0].style_count }} styles (background & clothes combinations)
                            </li>
                            <li class="flex items-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                2 hours
                            </li>
                        </ul>
                        <template v-if="$page.props.auth && $page.props.auth.user">
                            <ShinyButton :href="route('flows.create')"
                                class="py-2 px-2 sm:px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <template v-else>
                            <ShinyButton :href="route('quiz.index')"
                                class="py-2 px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <div class="bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 text-white text-sm font-bold py-1 text-center -m-8 mt-8 rounded-b-lg">
                            100% MONEY BACK GUARANTEE
                        </div>
                    </div>
                    <div
                        class="bg-white p-8 rounded-lg shadow-lg transform transition-transform hover:scale-105 border-4 border-blue-500">

                        <h2 class="text-2xl font-semibold mb-4">{{ packages[1].name }}</h2>
                        <p class="text-4xl font-bold mb-4">${{ packages[1].price }}</p>
                        <ul class="text-left mb-6 space-y-2">
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                {{ packages[1].photo_count }} headshots
                            </li>
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                {{ packages[1].style_count }} styles (background & clothes combinations)
                            </li>
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                1 hour
                            </li>
                            <div
                                class="absolute top-0 right-0 transform rotate-20 bg-blue-500 text-white text-xs font-bold px-2 py-1 shadow-lg">
                                Most popular
                            </div>
                        </ul>
                        <template v-if="$page.props.auth && $page.props.auth.user">
                            <ShinyButton :href="route('flows.create')"
                                class="py-2 px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <template v-else>
                            <ShinyButton :href="route('quiz.index')"
                                class="py-2 px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <div class="bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 text-white text-sm font-bold pt-1 pb-0 text-center -m-8 mt-7 rounded-b-sm">
                            100% MONEY BACK GUARANTEE
                        </div>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg transform transition-transform hover:scale-105">
                        <h2 class="text-2xl font-semibold mb-4">{{ packages[2].name }}</h2>
                        <p class="text-4xl font-bold mb-4">${{ packages[2].price }}</p>
                        <ul class="text-left mb-6 space-y-2">
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                {{ packages[2].photo_count }} headshots
                            </li>
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                {{ packages[2].style_count }} styles (background & clothes combinations)
                            </li>
                            <li class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5 text-blue-500 mr-2 size-6 flex-shrink-0">
                                    <path fill-rule="evenodd"
                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                        clip-rule="evenodd" />
                                </svg>
                                30 minutes
                            </li>
                        </ul>
                        <template v-if="$page.props.auth && $page.props.auth.user">
                            <ShinyButton :href="route('flows.create')"
                                class="py-2 px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <template v-else>
                            <ShinyButton :href="route('quiz.index')"
                                class="py-2 px-4 text-lg text-white bg-blue-500 rounded-lg shadow-lg hover:bg-blue-600">
                                Get Your Headshots Now →
                            </ShinyButton>
                        </template>
                        <div class="bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 text-white text-sm font-bold py-1 text-center -m-8 mt-8 rounded-b-lg">
                            100% MONEY BACK GUARANTEE
                        </div>
                    </div>

                </div>
            </div>
        </section>



        <div id="more">

<!-- Scrolling Cards Section -->
<section class="py-24 bg-white text-center">
    <div class="container mx-auto px-2 sm:px-6 py-8">
        <h1 class="text-5xl font-semibold mb-4">
            <span
                class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text py-8">Picture-perfect
                you.</span> Satisfaction guaranteed or money back.
        </h1>
        <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em]">If you don't find at least one profile photo that you like, we will refund you 100%!</h3>

        <div class="relative py-8">
            <button @click="scrollLeft(true)"
                class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-500 bg-opacity-50 text-white p-2 w-10 h-10 hover:bg-opacity-90 rounded-full shadow-lg z-10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>

            </button>
            <div ref="scrollContainer" class="scroll-container space-x-4">
                <figure v-for="i in 24" :key="i"
                    class="h-[740px] min-w-full sm:min-w-[405px] relative overflow-hidden rounded-3xl shadow-lg gallery-item">
                    <div class="absolute inset-0 bg-cover bg-center"
                        :style="{ backgroundImage: `url('/img/gallery/${i}.jpg')` }"></div>
                    <figcaption
                        class="absolute bottom-2 left-2 bg-gray-500 bg-opacity-45 text-gray-300 text-xs px-2 py-1 rounded-xl uppercase">
                        Created by AI
                    </figcaption>
                </figure>
            </div>
            <button @click="scrollRight(true)"
                class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-500 bg-opacity-50 text-white p-2 w-10 h-10 hover:bg-opacity-90 rounded-full shadow-lg z-10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>

            </button>
        </div>
    </div>
</section>






    <!-- Comparison section -->
 <section class="py-20 bg-gray-50 text-center">
            <div class="container mx-auto px-2 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4 pt-20">
                    <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">Better results</span>  without stressful posing
                </h1>
                <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em] pb-14">Our advanced AI creates professional headshots using a detailed 3D model of your face.</h3>
                    
                <div class="overflow-x-auto">
                    <Comparison />


                </div>
            </div>
        </section>

        <!-- Privacy Section -->
        <section class="py-24 bg-white text-center">
            <div class="container mx-auto px-2 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4">
                    <span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text">Privacy</span> by design
                </h1>
                <h3 class="text-xl font-semibold text-gray-500 tracking-[.011em] mb-12">Your data security and privacy are our top priorities.</h3>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 justify-center items-stretch">
                    <div class="bg-gray-50 p-8 rounded-xl shadow-sm transform transition-transform hover:scale-105 border border-gray-100">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-blue-500 text-white shadow-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-8 h-8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                            </svg>
                        </div>
                        <h2 class="text-2xl font-semibold mb-4 text-gray-700">Secure Data</h2>
                        <p class="text-gray-500">Your data is private, stored securely and you can delete it at any time.</p>
                    </div>
                    <div class="bg-gray-50 p-8 rounded-xl shadow-sm transform transition-transform hover:scale-105 border border-gray-100">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-blue-500 text-white shadow-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-8 h-8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
                            </svg>
                        </div>
                        <h2 class="text-2xl font-semibold mb-4 text-gray-700">Full Control</h2>
                        <p class="text-gray-500">Your photos are solely used to create your headshots and discarded afterwards.</p>
                    </div>
                    <div class="bg-gray-50 p-8 rounded-xl shadow-sm transform transition-transform hover:scale-105 border border-gray-100">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-blue-500 text-white shadow-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-8 h-8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
                            </svg>
                        </div>
                        <h2 class="text-2xl font-semibold mb-4 text-gray-700">Strictly Isolated</h2>
                        <p class="text-gray-500">Your AI model is isolated from others, under your control.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Frequently Asked Questions Section -->
        <section id="faq" class="py-12 bg-gray-50 text-center">
            <div class="container mx-auto px-2 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4 py-20">
                
                    Got<span class="bg-gradient-to-r from-blue-500 to-blue-700 text-transparent bg-clip-text"> questions?</span>
                </h1>
                <div class="mt-6 text-left grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div v-for="(faq, index) in faqs" :key="index" class="mb-2">
                        <button @click="toggleFaq(index)"
                            class="w-full flex justify-between items-center text-left text-lg font-semibold p-3 rounded-lg focus:outline-none border border-gray-300">
                            {{ faq.question }}
                            <svg :class="{ 'transform rotate-45': activeFaq === index }"
                                class="w-5 h-5 transition-transform duration-300" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 4v16m8-8H4"></path>
                            </svg>
                        </button>
                        <div v-if="activeFaq === index"
                            class="text-sm text-gray-700 p-3 border border-gray-200 rounded-lg">
                            {{ faq.answer }}
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- CTA Section -->
        <section class="p-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white text-center">
            <div class="container mx-auto px-0 sm:px-6">
                <h1 class="text-5xl font-semibold mb-4">Stay at home. Look your best.</h1>
                <h2 class="text-2xl font-semibold text-gray-200 tracking-[.011em] pb-5">No appointments, no studio — pro
                    headshots from the comfort of your own space. Satisfaction guaranteed or money back.
                </h2>
                <ShinyButton :href="route('quiz.index')"
                    class="py-6 px-10 text-lg text-white-900 border-none rounded-lg shadow-lg hover:bg-gray-200">
                    Try risk-free
                </ShinyButton>
            </div>
        </section>

        <!-- Footer -->
        <Footer />

    </div>





</template>
